import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { callAPI, IRoleMain, MasterPages, Method } from "../../../commonFunctions/CommonFunctions";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { HeaderList } from "../../../Components/Header/HeaderList";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";

export const FranchiseUsersList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();
 // const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);
  const [totalCount, setTotalCount] = useState<any>();
  const [franchiseUser,setFranchiseUser] = useState([])

  // const source = {
  //   url: "franchiseUsers/search",
  //   page: 1,
  //   pageSize: 10,
  //   filter: [],
  //   sort: [],
  // };
  
  useEffect(() => {
      const fetchFranchiseUsers = async () => {
  
        try {
          const response: any = await callAPI("franchiseUsers", Method.GET);
          if (response) {
            console.log("response is",response)
          setFranchiseUser(response.data);
          }
        } catch (error) {
          console.error("failed to retrieve data", error);
          showMessage("Something went wrong. Please try again.", "error");
        } 
      };
  
      fetchFranchiseUsers();
    }, []);

  /**
   *  Edit function
   * @param action
   * @param row
   */
  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/user/registration/${row?.userId}`);
    }
  };

  const columns: IColumns[] = [
    {
      header: "Full Name",
      fieldName: "fullName",
      tooltip: true
    },

    {
      header: "Email ID",
      fieldName: "email",
      tooltip: true
    },

    {
      header: "Created Date",
      fieldName: "createdDate",
      tooltip: true,
      type: "date"
    },
    {
      header: "Updated Date",
      fieldName: "updatedDate",
      tooltip: true,
      type: "date"
    },

    // {
    //   header: "Actions",
    //   fieldName: "actions",
    //   type: "action",
    //   actions: ["Edit" ],
    //   actionCallback: (action, row) => handleAction(action, row)
    // }
  ];

  const handleClick = () => {
    navigate("/user/registration");
  };
const transFormData = (data: any, totalCount: any) => {
    setTotalCount(totalCount)
    return data
  }
  return (
   <> 
   <HeaderList title="Franchise Users" type="card" info={`${totalCount || 0} Total Records`}  />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="productGrid"
            title="Franchise Users"
            columns={columns}
            // source={source}
            data={franchiseUser}
            addButton={{ label: "New", color: "secondary" }}
            onAddButtonClick={handleClick}
            transFormData={transFormData}
            headerType="HaderTopCornered"
          />
        </Grid>
      </Grid>
 
    </>
  );
});
